import './index.scss'

function initAwardsCarousels() {
    const carousels = document.querySelectorAll('.carousel--awards-association');

    const $args = {
        destroy: true,
        autoWidth: true,
        arrows: false,
        pagination: false,
        breakpoints: {
            992: {
                destroy: false,
                focus: 'center',
                gap: 0,
                type: "slide",
                arrows: false,
                trimSpace: false,
                padding: {
                    left: '20%',
                    right: '20%',
                },

            },
        },
    };
    for (let i = 0; i < carousels.length; i++ ) {
        new Splide(carousels[i], $args).mount();
    }
}
document.addEventListener('DOMContentLoaded', initAwardsCarousels)